<template>
  <div class="ivan-home">
    <div class="row">
      <!-- 快捷 -->
      <div class="col-sm-6">
        <div class="panel panel-info home-panel">
          <div class="panel-heading">
            <span class="home-panel-title">
              <i class="iconfont icon-favorite" />快捷
            </span>
          </div>
          <div class="panel-body home-panel__shortcut">
            <div class="row" style="display:table;width:100%;height:100%;">
              <div class="col-xs-6 text-center form-group shortcut-cell">
                <a href="javascript:;" class="shortcut-link" @click.prevent="goTodo">
                  <img class="shortcut-img" src="/ivan-images/user.png" alt="" />
                  <div class="shortcut-label">
                    <span>待我处理</span>
                    <span v-if="todoCount > 0">
                      <span>(</span>
                      <span class="text-danger">{{ todoCount > 99 ? '99+' : todoCount }}</span>
                      <span>)</span>
                    </span>
                  </div>
                </a>
              </div>
              <div class="col-xs-6 text-center form-group shortcut-cell">
                <div class="dropdown" :class="{ open: newOpen }" style="display:inline-block;" @click.stop>
                  <a href="javascript:;" class="shortcut-link dropdown-toggle" @click.prevent="newOpen = !newOpen">
                    <img class="shortcut-img" src="/ivan-images/send.png" alt="" />
                    <div class="shortcut-label">发起任务</div>
                  </a>
                  <ul v-show="newOpen" class="dropdown-menu" style="padding-top:8px;left:50%;transform:translateX(-50%);min-width:160px;">
                    <template v-for="(m, i) in models">
                      <li :key="m.modelId">
                        <a href="javascript:;" @click.prevent="onNew(m.path)">{{ m.modelName }}</a>
                      </li>
                      <li
                        v-if="i < models.length - 1"
                        :key="'d-' + m.modelId"
                        role="separator"
                        class="divider"
                      />
                    </template>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 最近待办 -->
      <div class="col-sm-6">
        <div class="panel panel-info home-panel">
          <div class="panel-heading">
            <span class="home-panel-title">
              <i class="iconfont icon-assessedbadge" />最近待办
            </span>
            <span class="pull-right home-panel-more" title="查看更多" @click="goTodo">
              <span
                v-if="todoCount > 0"
                class="badge"
                style="color:#fff;background-color:red;position:relative;top:-3px;"
              >{{ todoCount > 99 ? '99+' : todoCount }}</span>
              <i class="iconfont icon-moredot-bold" />
            </span>
          </div>
          <ul v-if="!recentTodos.length && !todoLoading" class="list-group">
            <li class="list-group-item">
              <div class="text-center text-muted">暂无待办业务</div>
            </li>
          </ul>
          <ul v-else class="list-group home-todo-list">
            <li v-for="row in recentTodos" :key="row.id" class="list-group-item">
              <div class="home-todo-name" :title="row.caseName">
                <a href="javascript:;" @click.prevent="openTodo(row)">{{ row.caseName }}</a>
              </div>
              <span class="pull-right text-muted home-todo-meta">
                <span class="home-todo-date">{{ fmtDate(row.receiveDate) }}</span>
                <span class="home-todo-user">{{ row.prevUser || '—' }}</span>
              </span>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-sm-6">
        <div class="panel panel-info home-panel">
          <div class="panel-heading">
            <span class="home-panel-title">
              <i class="iconfont icon-data" />采样任务统计
            </span>
          </div>
          <div class="panel-body">
            <div ref="pickChart" style="height:300px;" />
          </div>
        </div>
      </div>
      <div class="col-sm-6">
        <div class="panel panel-info home-panel">
          <div class="panel-heading">
            <span class="home-panel-title">
              <i class="iconfont icon-productfeatures" />分析任务统计
            </span>
          </div>
          <div class="panel-body">
            <div ref="labChart" style="height:300px;" />
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-sm-6">
        <div class="panel panel-info home-panel">
          <div class="panel-heading">
            <span class="home-panel-title">
              <i class="iconfont icon-remind" />仪器校准预警
            </span>
            <span class="pull-right home-panel-more" title="查看更多" @click="goInstruments">
              <span
                v-if="insWarnTotal > 0"
                class="badge"
                style="color:#fff;background-color:red;position:relative;top:-3px;"
              >{{ insWarnTotal > 99 ? '99+' : insWarnTotal }}</span>
              <i class="iconfont icon-moredot-bold" />
            </span>
          </div>
          <div class="panel-body" style="overflow-x:auto;">
            <table class="table table-responsive home-ins-table">
              <thead>
                <tr>
                  <th style="min-width:100px;">仪器名称</th>
                  <th style="min-width:50px;">型号</th>
                  <th style="min-width:100px;">校准到期</th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="!insWarnList.length">
                  <td colspan="3" class="text-center text-muted">暂无校准预警</td>
                </tr>
                <tr v-for="row in insWarnList" :key="row.id || row.InsID">
                  <td :class="{ 'text-danger': row.overdue || row.CountDownDays <= 0 }">
                    <div class="anCore-text-overflow" :title="row.name || row.InsName">{{ row.name || row.InsName || '—' }}</div>
                  </td>
                  <td :class="{ 'text-danger': row.overdue || row.CountDownDays <= 0 }">
                    <div class="anCore-text-overflow" :title="row.model || row.InsSize">{{ row.model || row.InsSize || '—' }}</div>
                  </td>
                  <td :class="{ 'text-danger': row.overdue || row.CountDownDays <= 0 }">
                    <div class="anCore-text-overflow">{{ fmtDate(row.expiry || row.EffectiveDate) }}</div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as echarts from 'echarts'
import api from '@/utils/api'
import { NEW_CASE_MODELS } from '@/config/ivanMenus'
import { fetchTodoFlatRows } from '@/utils/todoAdapter'
import { isAdmin, isTaskDispatcher } from '@/utils/user'

export default {
  name: 'HomePortal',
  data() {
    return {
      models: NEW_CASE_MODELS,
      newOpen: false,
      todoLoading: false,
      todoCount: 0,
      recentTodos: [],
      pickChartInst: null,
      labChartInst: null,
      insWarnTotal: 0,
      insWarnList: []
    }
  },
  mounted() {
    document.addEventListener('click', this.onDocClick)
    window.addEventListener('resize', this.onResize)
    this.reload()
  },
  activated() {
    this.reload()
  },
  beforeDestroy() {
    document.removeEventListener('click', this.onDocClick)
    window.removeEventListener('resize', this.onResize)
    if (this.pickChartInst) this.pickChartInst.dispose()
    if (this.labChartInst) this.labChartInst.dispose()
  },
  methods: {
    onDocClick() {
      this.newOpen = false
    },
    onResize() {
      if (this.pickChartInst) this.pickChartInst.resize()
      if (this.labChartInst) this.labChartInst.resize()
    },
    canCreate() {
      return isAdmin() || isTaskDispatcher()
    },
    fmtDate(v) {
      if (!v) return '—'
      return String(v).slice(0, 10)
    },
    goTodo() {
      this.$router.push({ path: '/todo', query: { from: 'home' } }).catch(() => {})
    },
    goInstruments() {
      this.$router.push('/instruments').catch(() => {})
    },
    onNew(path) {
      this.newOpen = false
      if (!this.canCreate()) {
        this.$message.warning('当前账号无发起权限')
        return
      }
      this.$router.push(path).catch(() => {})
    },
    openTodo(row) {
      if (row.route) this.$router.push(row.route).catch(() => {})
      else this.goTodo()
    },
    async reload() {
      this.todoLoading = true
      try {
        const rows = await fetchTodoFlatRows()
        this.todoCount = rows.length
        this.recentTodos = rows.slice(0, 8)
      } catch (e) {
        this.todoCount = 0
        this.recentTodos = []
      } finally {
        this.todoLoading = false
      }
      await Promise.all([this.loadCharts(), this.loadInsWarn()])
    },
    async loadInsWarn() {
      this.insWarnTotal = 0
      this.insWarnList = []
      try {
        const res = await api.get('yn_portal_ins_warn', { warnDays: 365 })
        const d = res && res.data
        const list = (d && (d.DataList || d.list)) || []
        if (!Array.isArray(list)) return
        this.insWarnTotal = (d && d.total != null) ? Number(d.total) : list.length
        this.insWarnList = list.slice(0, 7)
      } catch (e) { /* ignore */ }
    },
    monthKeys(n = 7) {
      const out = []
      const d = new Date()
      for (let i = n - 1; i >= 0; i--) {
        const t = new Date(d.getFullYear(), d.getMonth() - i, 1)
        const y = t.getFullYear()
        const m = String(t.getMonth() + 1).padStart(2, '0')
        out.push({ key: `${y}-${m}`, label: `${t.getMonth() + 1}月` })
      }
      return out
    },
    bucketMonth(dateStr) {
      const s = String(dateStr || '').slice(0, 7)
      return /^\d{4}-\d{2}$/.test(s) ? s : ''
    },
    async loadCharts() {
      let months = this.monthKeys(7)
      let pick = months.map(() => ({ total: 0, done: 0 }))
      let lab = months.map(() => ({ total: 0, done: 0 }))
      try {
        const res = await api.get('yn_portal_month_stats')
        const d = res && res.data
        if (d && d.ok && Array.isArray(d.pick) && Array.isArray(d.lab)) {
          if (Array.isArray(d.months) && d.months.length) {
            months = d.months.map(m => ({
              key: m.key,
              label: m.label || m.key
            }))
          }
          pick = d.pick
          lab = d.lab
        } else {
          const built = await this.buildStatsLocal(months)
          pick = built.pick
          lab = built.lab
        }
      } catch (e) {
        const built = await this.buildStatsLocal(months)
        pick = built.pick
        lab = built.lab
      }
      this.$nextTick(() => {
        this.renderChart('pickChart', 'pickChartInst', months, pick)
        this.renderChart('labChart', 'labChartInst', months, lab)
      })
    },
    async buildStatsLocal(months) {
      const idx = {}
      months.forEach((m, i) => { idx[m.key] = i })
      const pick = months.map(() => ({ total: 0, done: 0 }))
      const lab = months.map(() => ({ total: 0, done: 0 }))
      try {
        const rw = await api.get('yn_rwfp_list')
        const list = Array.isArray(rw.data) ? rw.data : []
        list.forEach(r => {
          const k = this.bucketMonth(r.fprq || r.wcrq || r.gxsj || r.cjsj)
          if (k == null || idx[k] == null) return
          pick[idx[k]].total++
          if (String(r.rwzt) === 'done' || String(r.rwzt) === '3') pick[idx[k]].done++
        })
      } catch (e) { /* ignore */ }
      try {
        const bd = await api.get('yn_bdsl_list')
        const list = Array.isArray(bd.data) ? bd.data : []
        list.forEach(r => {
          const mbid = Math.abs(parseInt(r.mbid, 10) || 0)
          if (!mbid || mbid === 135 || mbid === 134) return
          // 实验室/现场表（054/056/093 + lab）
          if (mbid < 50 && ![54, 56, 93].includes(mbid)) return
          const k = this.bucketMonth(r.gxsj || r.cjsj)
          if (k == null || idx[k] == null) return
          lab[idx[k]].total++
          const zt = String(r.bdzt || '')
          if (zt === 'approved' || zt === 'done' || zt === 'signed_pzr') lab[idx[k]].done++
        })
      } catch (e) { /* ignore */ }
      return { pick, lab }
    },
    renderChart(refName, chartKey, months, series) {
      const el = this.$refs[refName]
      if (!el) return
      if (!this[chartKey]) this[chartKey] = echarts.init(el)
      const cats = months.map(m => m.label)
      const total = series.map(s => s.total)
      const done = series.map(s => s.done)
      const rate = series.map(s => (s.total ? +(s.done / s.total * 100).toFixed(1) : 0))
      this[chartKey].setOption({
        color: ['#7cb5ec', '#90ed7d', '#f7a35c'],
        tooltip: { trigger: 'axis' },
        legend: { data: ['任务量', '完成量', '完成率'], top: 0 },
        grid: { left: 48, right: 56, top: 40, bottom: 32 },
        xAxis: { type: 'category', data: cats, axisPointer: { type: 'shadow' } },
        yAxis: [
          { type: 'value', name: '数量（条）', min: 0 },
          {
            type: 'value',
            name: '完成率（%）',
            min: 0,
            max: 100,
            axisLabel: { formatter: '{value}%' }
          }
        ],
        series: [
          { name: '任务量', type: 'bar', data: total, barMaxWidth: 28 },
          { name: '完成量', type: 'bar', data: done, barMaxWidth: 28 },
          {
            name: '完成率',
            type: 'line',
            yAxisIndex: 1,
            data: rate,
            smooth: true,
            symbolSize: 6
          }
        ]
      }, true)
    }
  }
}
</script>

<style scoped>
.ivan-home {
  padding: 0 4px 12px;
}
.home-panel {
  height: 381px;
  margin-bottom: 15px;
}
.home-panel-title {
  font-weight: bold;
}
.home-panel-more {
  cursor: pointer;
}
.home-panel__shortcut {
  height: calc(100% - 44px);
  width: 100%;
}
.shortcut-cell {
  margin-bottom: 25px;
  display: table-cell;
  vertical-align: middle;
  float: none;
  width: 50%;
}
.shortcut-link {
  display: inline-block;
  color: #333;
  text-decoration: none;
}
.shortcut-link:hover,
.shortcut-link:focus {
  color: #337ab7;
  text-decoration: none;
}
.shortcut-img {
  display: block;
  margin: 0 auto 8px;
  cursor: pointer;
  max-width: 72px;
  height: auto;
}
.shortcut-label {
  padding-left: 6px;
  font-size: 14px;
}
.text-danger {
  color: red;
}
.home-todo-list {
  max-height: 330px;
  overflow: auto;
  margin-bottom: 0;
}
.home-todo-name {
  width: calc(100% - 200px);
  display: inline-block;
  vertical-align: middle;
}
.home-todo-name a {
  display: block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.home-todo-meta {
  width: 200px;
  display: inline-block;
  vertical-align: middle;
}
.home-todo-date {
  width: 108px;
  display: inline-block;
  float: left;
}
.home-todo-user {
  display: inline-block;
  width: 70px;
  margin-left: 3px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.home-ins-table {
  margin-bottom: 0;
}
.home-ins-table > thead > tr > th,
.home-ins-table > tbody > tr > td {
  padding: 6px 8px;
  vertical-align: middle;
}
.home-ins-table .text-danger {
  color: #a94442;
}
</style>
